import React from "react";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <div className="bg-white text-gray-800 font-sans">
      <div
        className="relative w-full h-[150px] sm:h-[200px] md:h-[250px] mb-3 bg-cover bg-center overflow-hidden"
        style={{
          backgroundImage: `url(${require("../../assets/images/home/img_bag.jpg")})`,
        }}
      >
        {/* Black overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-white text-center p-4">
          {/* Page Title */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl mb-2 tracking-wide">
            Terms & Conditions
          </h2>

          {/* Breadcrumb */}
          <nav className="flex items-center space-x-2 text-sm text-gray-200 bg-black/40 px-4 py-2 rounded-md max-w-fit mx-auto">
            <Link to="/" className="hover:text-white">
              Home
            </Link>
            <span>/</span>
            <span>Terms & Conditions</span>
          </nav>
        </div>
      </div>
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main content container */}
        <div className="space-y-12 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Introduction
            </h2>
            <p className="mb-4">
              Luggaelegacy and/or its affiliates provide website features and
              other products and services to you when you visit or shop at
              www.luggaelegacy.com. Luggaelegacy provides these services subject to
              the following terms and conditions.
            </p>
            <p>
              By using our products or services, you willfully and
              unconditionally agree to these conditions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Your Account
            </h2>
            <p>
              If you register on our website, you are responsible for
              maintaining the confidentiality of your account and password and
              for restricting access to your computer. You agree to accept
              responsibility for all activities that occur under your account or
              password. Luggaelegacy reserves the right to refuse service,
              terminate accounts, remove or edit content, or cancel orders in
              its sole discretion.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Orders & Payments
            </h2>
            <h3 className="text-xl font-semibold tracking-wider uppercase mb-3 text-gray-800">
              Pricing Policy
            </h3>
            <p className="mb-4">
              All prices shown on the website are in Indian Rupees (₹) and are
              inclusive of all applicable taxes. Prices may change and offers
              can be withdrawn at any time without prior notice.
            </p>

            <h3 className="text-xl font-semibold tracking-wider uppercase mb-3 text-gray-800">
              Order Cancellation
            </h3>
            <p className="mb-4">
              You can cancel your order online by logging into your account
              before the item has been dispatched. If your order has already
              been dispatched, we will not be able to process the cancellation.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Shipping & Risk of Loss
            </h2>
            <p>
              All items purchased from Luggaelegacy are made pursuant to a
              shipment contract. This means that the risk of loss and title for
              such items pass to you upon our delivery to the carrier for
              dispatch.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Trademarks & Copyright
            </h2>
            <p>
              All graphics, logos, page headers, button icons, scripts, and
              service names included in or made available through our service
              are trademarks or service marks of Luggaelegacy. By using the
              services, you do not get any right for copying or using the same.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold tracking-widest uppercase mb-4 text-gray-800">
              Contact Us
            </h2>
            <p>
              If you have any questions about these Terms and Conditions, please
              contact us at:
              <a
                href="mailto:support@galaxybag.com"
                className="text-black font-semibold hover:underline ml-2"
              >
                support@galaxybag.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
